const HandshqApp = {};

module.exports = HandshqApp;
